import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { JourneyTopBar, JourneyFooter } from "@/components/JourneyChrome";

export default function PurchaseCancel() {
  return (
    <div className="flex min-h-screen flex-col bg-[#FAF8F4] text-[#171717]" data-testid="purchase-cancel-page">
      <JourneyTopBar showSignIn={false} />
      <main className="flex flex-1 items-center justify-center px-5 py-16">
        <div className="w-full max-w-lg rounded-3xl pe-surface p-9 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#F0EBE3] text-[#70584A]">
            <XCircle className="h-7 w-7" />
          </span>
          <h1 className="mt-6 font-serif text-2xl text-[#171717]">Checkout canceled</h1>
          <p className="mt-3 text-[15px] leading-relaxed text-[#525252]">
            No charge was made. Whenever you're ready, your Paycheck Edit is one click away.
          </p>
          <Link
            to="/"
            data-testid="cancel-back-link"
            className="mt-7 inline-flex min-h-[50px] items-center justify-center rounded-full bg-[#2F6B57] px-8 text-sm font-semibold text-white transition-colors hover:bg-[#255544]"
          >
            Back to The Paycheck Edit
          </Link>
        </div>
      </main>
      <JourneyFooter />
    </div>
  );
}
